import type { JobCheckoutViewModel } from '@/features/jobs/drafting/checkout/JobCheckoutViewModel'
import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'

/**
 * The call center's checkout page.
 */
export class CallCenterCheckoutViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  constructor(private readonly _getJobCheckoutVm: () => JobCheckoutViewModel) {}

  /** @inheritDoc */
  activate() {
    this._lifecycle.activate()
    this._refresh(this._lifecycle.signal).catch(() => undefined)
  }

  /** @inheritDoc */
  deactivate() {
    this._lifecycle.deactivate()
  }

  /**
   * Refreshes the loaded job and its price summary.
   *
   * @param signal
   */
  private async _refresh(signal: AbortSignal) {
    const checkoutVm = this._getJobCheckoutVm()
    if (!checkoutVm.job.id || checkoutVm.fetchJobInfo.pending) {
      return
    }

    await Promise.all([
      checkoutVm.fetchQuote(signal),
      checkoutVm.refreshJob(signal),
    ])
  }
}
